<style lang="stylus">
    .ft-connectormore
        position absolute
        background $ft-bgcolor
        box-shadow $ft-boxshadow
        border-radius $ft-boxradius
        max-height 300px
        padding 6px

        .ft-arrowsizebox
            min-width 92px
            height 208px
            background $ft-bgcolor
            padding 6px
            border-radius $ft-boxradius

            li
                position relative
                border-radius 6px
                display flex
                align-items center
                padding-left 26px
                padding-right 5px
                height 28px
                white-space nowrap

                &.active::before
                    line-height 0
                    content url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath stroke='%23424242' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M4 8l2.5 2.5L12 5'/%3E%3C/svg%3E")
                    position absolute
                    display block
                    left 3px
                    top 7px
                    width 16px
                    height 16px

                p
                    font-size 12px
                    color var(--text-color-primary)

                &:not(.active):hover
                    background $ft-hover

                &.active
                    background $ft-active
</style>

<template>
    <div class="ft-connectormore">
        <FTSubMenu :imgIcon="'connector-begin'" :text="$t('begin')" :isExpand="true" :disable="!isSelect">
            <template #content>
                <ul class="ft-arrowsizebox">
                    <li
                        v-for="item in 7"
                        :class="{ 'ft-has-checked-list-item': BSText(item) == activeBSText, active: BSText(item) == activeBSText }"
                        :key="BSText(item)"
                        @click="setBegin(BSText(item))"
                    >
                        {{ $t(BSText(item)) }}
                    </li>
                </ul>
            </template>
        </FTSubMenu>
        <FTSubMenu :imgIcon="'connector-end'" :text="$t('end')" :isExpand="true" :disable="!isSelect">
            <template #content>
                <ul class="ft-arrowsizebox">
                    <li
                        v-for="item in 7"
                        :class="{ 'ft-has-checked-list-item': ESText(item) == activeESText, active: ESText(item) == activeESText }"
                        :key="ESText(item)"
                        @click="setEnd(ESText(item))"
                    >
                        {{ $t(ESText(item)) }}
                    </li>
                </ul>
            </template>
        </FTSubMenu>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import FTSubMenu from "../public/FTSubMenu.vue";
    declare var eFmtSetFlag;
    enum ArrowSize {
        "Very Small" = 2,
        Small = 3,
        Middle = 4,
        Large = 6,
        "Extra Large" = 9,
        Jumbo = 12,
        Colossal = 14,
    }
    @Component({
        components: {
            FTSubMenu,
        },
    })
    export default class ConnectorMore extends Vue {
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get activeBSText() {
            return ArrowSize[this.activeBSType];
        }
        get activeESText() {
            return ArrowSize[this.activeESType];
        }
        get activeBSType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.startArrowSize;
            return null;
        }
        get activeESType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.endArrowSize;
            return null;
        }
        BSText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        ESText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        setBegin(data) {
            window["_view"].setFmt(
                {
                    _size: ArrowSize[data],
                },
                eFmtSetFlag.LineBASize
            );
            window["_view"].setActiveShapeFmt();
            this.sensors.track("editConnector", {
                Catalogues: "shortcutToolbar",
                content: "LineBASize",
            });
        }
        setEnd(data) {
            window["_view"].setFmt(
                {
                    _size: ArrowSize[data],
                },
                eFmtSetFlag.LineEASize
            );
            window["_view"].setActiveShapeFmt();
            this.sensors.track("editConnector", {
                Catalogues: "shortcutToolbar",
                content: "LineEASize",
            });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "begin": "起始箭头大小",
        "end": "终点箭头大小",
        "Very Small": "非常小",
        "Small": "小",
        "Middle": "中",
        "Large": "大",
        "Extra Large": "特大",
        "Jumbo": "巨大",
        "Colossal": "超大"
    },
    "en": {
        "begin": "Begin Arrow Size",
        "end": "End Arrow Size",
        "Very Small": "Very Small",
        "Small": "Small",
        "Middle": "Middle",
        "Large": "Large",
        "Extra Large": "Extra Large",
        "Jumbo": "Jumbo",
        "Colossal": "Colossal"
    },
    "fr": {
        "begin": "Taille de la flèche du début",
        "end": "Taille de la flèche d'extrémité",
        "Very Small": "Très petit",
        "Small": "Petit ",
        "Middle": "Moyen",
        "Large": "Grand",
        "Extra Large": "Très Grand",
        "Jumbo": "Géant",
        "Colossal": "Colossal"
    },
    "de": {
        "begin": "Pfeilanfang-Größe",
        "end": "Pfeilende-Größe",
        "Very Small": "Sehr klein",
        "Small": "Klein",
        "Middle": "Mittel",
        "Large": "Groß",
        "Extra Large": "Sehr groß",
        "Jumbo": "Jumbo",
        "Colossal": "Kolossal"
    },
    "jp": {
        "begin": "始点矢印のサイズ",
        "end": "終点矢印のサイズ",
        "Very Small": "極小",
        "Small": "小",
        "Middle": "中",
        "Large": "大",
        "Extra Large": "極大",
        "Jumbo": "巨大",
        "Colossal": "超大"
    },
    "es": {
        "begin": "Comenzar el tamaño de la flecha",
        "end": "Tamaño de la flecha final",
        "Very Small": "Muy pequeño",
        "Small": "Pequeño",
        "Middle": "Medio",
        "Large": "Gran",
        "Extra Large": "Extra grande",
        "Jumbo": "Jumbo",
        "Colossal": "Colosal"
    },
    "pt": {
        "begin": "Comece o Tamanho da Seta",
        "end": "Tamanho da Seta Final",
        "Very Small": "Muito Pequeno",
        "Small": "Pequeno",
        "Middle": "Médio",
        "Large": "Grande",
        "Extra Large": "Muito Grande",
        "Jumbo": "Enorme",
        "Colossal": "Colossal"
    },
    "it": {
        "begin": "Inizia la dimensione della freccia",
        "end": "Dimensione freccia finale",
        "Very Small": "Molto Piccolo",
        "Small": "Piccolo",
        "Middle": "Medio",
        "Large": "Grande",
        "Extra Large": "Molto Grande",
        "Jumbo": "Enorme",
        "Colossal": "Colossale"
    },
    "tw": {
        "begin": "箭頭（開始）大小",
        "end": "箭頭（結束）大小",
        "Very Small": "非常小",
        "Small": "小",
        "Middle": "中",
        "Large": "大",
        "Extra Large": "特大",
        "Jumbo": "巨大",
        "Colossal": "超大"
    },
    "kr": {
        "begin": "화살표 머리 크기",
        "end": "화살표 꼬리 크기",
        "Very Small": "아주 작다",
        "Small": "소",
        "Middle": "중",
        "Large": "대",
        "Extra Large": "특대",
        "Jumbo": "거대",
        "Colossal": "초대"
    }
}
</i18n>
